import { render, staticRenderFns } from "./BillItems.vue?vue&type=template&id=638fe4e4"
import script from "./BillItems.vue?vue&type=script&setup=true&lang=js"
export * from "./BillItems.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports